"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};
var cssColorUtils_exports = {};
__export(cssColorUtils_exports, {
  colorToSameTypeString: function colorToSameTypeString() {
    return _colorToSameTypeString;
  },
  hexStringToRgbaColor: function hexStringToRgbaColor() {
    return _hexStringToRgbaColor;
  },
  stringToHslaColor: function stringToHslaColor() {
    return _stringToHslaColor;
  },
  stringToSameTypeColor: function stringToSameTypeColor() {
    return _stringToSameTypeColor;
  }
});
module.exports = __toCommonJS(cssColorUtils_exports);
var import_predicates = require("./predicates");
var CLEAN_HSLA_REGEX = /[hsla()]/g;
var CLEAN_RGBA_REGEX = /[rgba()]/g;
var _stringToHslaColor = function _stringToHslaColor(value) {
  if (value === "transparent") {
    return {
      h: 0,
      s: 0,
      l: 0,
      a: 0
    };
  }
  if ((0, import_predicates.isValidHexString)(value)) {
    return hexStringToHslaColor(value);
  }
  if ((0, import_predicates.isValidHslaString)(value)) {
    return parseHslaString(value);
  }
  if ((0, import_predicates.isValidRgbaString)(value)) {
    return rgbaStringToHslaColor(value);
  }
  return null;
};
var _stringToSameTypeColor = function _stringToSameTypeColor(value) {
  value = value.trim();
  if ((0, import_predicates.isValidHexString)(value)) {
    return value.startsWith("#") ? value : "#".concat(value);
  }
  if ((0, import_predicates.isValidRgbaString)(value)) {
    return parseRgbaString(value);
  }
  if ((0, import_predicates.isValidHslaString)(value)) {
    return parseHslaString(value);
  }
  if ((0, import_predicates.isTransparent)(value)) {
    return value;
  }
  return "";
};
var _colorToSameTypeString = function _colorToSameTypeString(color) {
  if (typeof color === "string" && ((0, import_predicates.isValidHexString)(color) || (0, import_predicates.isTransparent)(color))) {
    return color;
  }
  if ((0, import_predicates.isRGBColor)(color)) {
    return rgbaColorToRgbaString(color);
  }
  if ((0, import_predicates.isHSLColor)(color)) {
    return hslaColorToHslaString(color);
  }
  return "";
};
var _hexStringToRgbaColor = function _hexStringToRgbaColor(hex) {
  hex = hex.replace("#", "");
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  return {
    r: r,
    g: g,
    b: b
  };
};
var rgbaColorToRgbaString = function rgbaColorToRgbaString(color) {
  var a = color.a,
    b = color.b,
    g = color.g,
    r = color.r;
  return color.a === 0 ? "transparent" : color.a != void 0 ? "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(a, ")") : "rgb(".concat(r, ",").concat(g, ",").concat(b, ")");
};
var hslaColorToHslaString = function hslaColorToHslaString(color) {
  var h = color.h,
    s = color.s,
    l = color.l,
    a = color.a;
  var sPerc = Math.round(s * 100);
  var lPerc = Math.round(l * 100);
  return color.a === 0 ? "transparent" : color.a != void 0 ? "hsla(".concat(h, ",").concat(sPerc, "%,").concat(lPerc, "%,").concat(a, ")") : "hsl(".concat(h, ",").concat(sPerc, "%,").concat(lPerc, "%)");
};
var hexStringToHslaColor = function hexStringToHslaColor(hex) {
  var rgbaString = _colorToSameTypeString(_hexStringToRgbaColor(hex));
  return rgbaStringToHslaColor(rgbaString);
};
var rgbaStringToHslaColor = function rgbaStringToHslaColor(rgba) {
  var rgbaColor = parseRgbaString(rgba);
  var r = rgbaColor.r / 255;
  var g = rgbaColor.g / 255;
  var b = rgbaColor.b / 255;
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h, s;
  var l = (max + min) / 2;
  if (max == min) {
    h = s = 0;
  } else {
    var d = max - min;
    s = l >= 0.5 ? d / (2 - (max + min)) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d * 60;
        break;
      case g:
        h = ((b - r) / d + 2) * 60;
        break;
      default:
        h = ((r - g) / d + 4) * 60;
        break;
    }
  }
  var res = {
    h: Math.round(h),
    s: s,
    l: l
  };
  var a = rgbaColor.a;
  if (a != void 0) {
    res.a = a;
  }
  return res;
};
var parseRgbaString = function parseRgbaString(str) {
  var _str$replace$split$ma = str.replace(CLEAN_RGBA_REGEX, "").split(",").map(function (c) {
      return Number.parseFloat(c);
    }),
    _str$replace$split$ma2 = _slicedToArray(_str$replace$split$ma, 4),
    r = _str$replace$split$ma2[0],
    g = _str$replace$split$ma2[1],
    b = _str$replace$split$ma2[2],
    a = _str$replace$split$ma2[3];
  return {
    r: r,
    g: g,
    b: b,
    a: a
  };
};
var parseHslaString = function parseHslaString(str) {
  var _str$replace$split$ma3 = str.replace(CLEAN_HSLA_REGEX, "").split(",").map(function (c) {
      return Number.parseFloat(c);
    }),
    _str$replace$split$ma4 = _slicedToArray(_str$replace$split$ma3, 4),
    h = _str$replace$split$ma4[0],
    s = _str$replace$split$ma4[1],
    l = _str$replace$split$ma4[2],
    a = _str$replace$split$ma4[3];
  return {
    h: h,
    s: s / 100,
    l: l / 100,
    a: a
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  colorToSameTypeString: _colorToSameTypeString,
  hexStringToRgbaColor: _hexStringToRgbaColor,
  stringToHslaColor: _stringToHslaColor,
  stringToSameTypeColor: _stringToSameTypeColor
});